import React, { useEffect, useState } from 'react';
import AnimatedLoader from '../../../components/AnimatedLoader';
import useMoengage from '../../../hooks/useMoengage';
import '../../../styles/components/MyJobListingForRejectedCandidates/MyJobListingForRejectedCandidates.scss';
import AppConstants from '../../../constants/AppConstants';
import zomatoLogo from '../../../assets/zomato.png';
import uberLogo from '../../../assets/uber.png';
import defaultCompanyIcon from '../../../assets/defaultCompany.svg';
import swiggyLogo from '../../../assets/swiggy.png';
import porterLogo from '../../../assets/porter.jpeg';
import shadowfaxLogo from '../../../assets/shadowfax.png';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ApartmentTwoToneIcon from '@mui/icons-material/ApartmentTwoTone';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { func } from 'prop-types';
import { ConstructionRounded } from '@mui/icons-material';

function MyJobListingForRejectedCandidatesCard(props) {

    const { post,selectCompany,idx,handleClick,userId} = props;

    return(
        <div>
        <div className="my_job_card" style={{minHeight:'100%'}}>
            <div>
                <div className="row">
                    <div className="col-2">
                        <img
                            src={selectCompany(post.companyName)}
                            alt="company logo"
                            style={{ width: '40px', borderRadius: '30%' }}
                        />
                    </div>
                    <div className="col-7">
                        <div>{post.jobRole}</div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'start',
                                fontFamily: 'Open Sans',
                                fontStyle: 'normal',
                                fontWeight: '600',
                                fontSize: '10px',
                                lineHeight: '150%',
                                color: '#888888',
                            }}
                        >
                            <ApartmentTwoToneIcon sx={{ fontSize: 13 }} />
                            <div style={{ marginLeft: '2px' }}> {post.companyName} </div>

                            <LocationOnOutlinedIcon sx={{ fontSize: 13, marginLeft: '6px' }} />
                            <div> {post.companyLocation}</div>
                        </div>
                        <div style={{ fontSize: '12px', lineHeight: '18px', color: '#555555' }}>{post.salary} per month</div>
                    </div>

                    <div className="col-3">
                        <span style={{
                            backgroundColor: '#efd0d0',
                            borderRadius: '10px',
                            padding: '5px',
                            color: '#d34612',
                            fontSize: '8px',
                            textTransform:'uppercase',
                            fontFamily:'Open Sans',
                            fontWeight:'bold',
                            // letterSpacing:0.6,
                        }}
                        >
                            {post.jobType}
                        </span>
                    </div>
                </div>
            </div>

            <div style={{marginRight:'12px', marginTop:'20px'}}>
                <button
                    type="button"
                    className={`apply_button ${post.isApplied ? "disabled_button" : ""}`}
                    style={{
                        width: '100%',
                        color: 'white',
                    }}
                    onClick={() => handleClick(post,idx)}
                    disabled={post.isApplied}
                >
                    {post.isApplied ? 'Applied' : 'Apply'}
                </button>
                <hr/>
            </div>

        </div>
        <br/>
    </div>
    );

}

export default MyJobListingForRejectedCandidatesCard;